"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Window = _interopRequireDefault(require("../../base/Window/Window"));

require("./AboutWnd.css");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["title", "content", "visible", "onOk"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AboutWnd = function AboutWnd(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "About" : _ref$title,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? "" : _ref$content,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      onOk = _ref.onOk,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Window.default, _objectSpread(_objectSpread({
    title: title,
    collapsible: true,
    onOk: onOk,
    visible: visible
  }, otherProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "rolext-about-wnd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
        children: "React-OlExt 0.1 Beta"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
        children: "Components for Building Web Map Applications"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
            className: "rolext-about-wnd-link",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
              rel: "noreferrer",
              href: "https://mapuiexts.github.io/react-olext.github.io/en/v0.1/apidoc/",
              target: "_blank",
              children: "API Docs"
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
            className: "rolext-about-wnd-link ",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
              rel: "noreferrer",
              href: "https://github.com/mapuiexts/React-OlExt",
              target: "_blank",
              children: "Source Code"
            })
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "rolext-about-wnd-content",
        children: content
      })]
    })
  }));
};

var _default = AboutWnd;
exports.default = _default;